import styled from "styled-components";
import "../../../../styles/variables.css";

export const SignatureDescription = styled.span`
  font-size: var(--fs15);
  margin-left: 15px;
`;
